import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import Request, { LAPI_URL } from "../../../../request";
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { Card, Row, Col, Button, Form, Tabs, notification } from "antd";
import _ from 'lodash';

const { TabPane } = Tabs;


const currentUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

@Form.create()
class UpdateBranch extends React.Component {
    state = {
        data: {},
        countryCodes: [],
        countries: [],
        states: [],
        cities: [],
        plans: [],
        loading: true,
    };

    callback = (key) => {
        let { data } = this.state;
        setTimeout(() => {
            this.props.form.setFieldsValue(data)
        }, 10)

        this.setState({ activeKey: key })
    }


    loadInitialData = async () => {
        try {
            let response = await Request.getBranch(currentUser.userBranch);
            let docLoaded = response && response.doc;

            if (docLoaded) {
                await this.loadStates(docLoaded.branchCountryId);
                await this.loadCities(docLoaded.branchStateId);

                this.props.form.setFieldsValue(docLoaded);
                this.setState({ data: docLoaded });
            }

        } catch (error) {
            console.error(error);
        }
    }

    loadCountries = async () => {
        let params = {
            results: 200,
            sortField: "countryName",
            sortOrder: "ascend",
        };

        let response = await Request.getCountriesWithoutAuth({ ...params })
        let countryCodes = [];
        response.data = response.data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.countryName });
            if (vv.countryPhoneCode && vv.countryPhoneCode !== "") {
                countryCodes.push({ id: vv.countryPhoneCode, display: vv.countryPhoneCode });
            }
            return temp;
        }, []);

        this.setState({ countries: response.data, countryCodes })
    }

    loadStates = async (id) => {
        try {
            let response = await Request.loadStates(id);

            let states = [];

            if (response && response.result && response.result.length) {
                states = response.result.reduce((temp, val) => {
                    temp.push({
                        _id: val._id,
                        key: val._id,
                        display: val.stateName
                    });
                    return temp;
                }, []);
            }

            this.setState({ states });

        } catch (error) {
            console.error("loadStates error:", error);
            this.setState({ states: [] });
        }
    }

    getAgentTypePlans = async (agentType = "Branch") => {
        let response = await Request.getAgentTypePlans(agentType);
        const result = response.result.reduce((temp, val) => {
            temp.push({ _id: val._id, key: val._id, display: val.planName });
            return temp;
        }, []);

        this.setState({ plans: result })
    }

    loadCities = async (id) => {
        try {
            let response = await Request.loadCities(id);

            let cities = [];

            if (response && response.result && response.result.length) {
                cities = response.result.reduce((temp, val) => {
                    temp.push({
                        _id: val._id,
                        key: val._id,
                        display: val.cityName
                    });
                    return temp;
                }, []);
            }

            this.setState({ cities });

        } catch (error) {
            console.error("loadCities error:", error);
            this.setState({ cities: [] });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let { form } = this.props;
        let { data } = this.state;
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            values._id = data._id;
            values.loginId = data.loginId;
            values.branchAssociatePartner = data.branchAssociatePartner;
            let x = await Request.updateBranch(values);
            if (!x.error) {
                notification.success({
                    message: "Success",
                    description: x.msg,
                });
            } else {
                notification.error({
                    message: "Error Saving",
                    description: x.msg,
                });
            }
        })
    }



    componentDidMount() {
        this.loadInitialData();
        this.loadCountries();
        this.getAgentTypePlans('Branch');
    }


    render() {
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        let { data, countries, countryCodes, states, cities, plans } = this.state;
        const inputTypes = [
            {
                tabTitle: "Basic Details",
                fields: [
                    {
                        label: "Branch Name",
                        key: "branchName",
                        disabled: true
                        // required: true,
                    },
                    {
                        label: "Firm Name",
                        key: "firmName",
                        required: true,
                    },
                    {
                        label: "Firm Logo",
                        key: "companyLogo",
                        type: "file",
                    },
                    {
                        label: "Invoice Header Image",
                        key: "invoiceHeaderImage",
                        type: "file",
                    },
                    {
                        label: "Invoice Footer Image",
                        key: "invoiceFooterImage",
                        type: "file",
                    },
                    {
                        label: "GST Number (If Applicable)",
                        key: "gstNumber",
                    },
                    {
                        label: "PAN Number (If Applicable)",
                        key: "panNumber",
                    },
                    {
                        label: "Address",
                        key: "branchAddress",
                        type: "textArea",
                        rows: 6,
                        required: true,
                    },
                    {
                        label: "Select Country",
                        key: "branchCountryId",
                        required: true,
                        type: "select",
                        showSearch: true,
                        options: countries,
                        onChange: (v) => {
                            this.props.form.setFieldsValue({
                                branchCountryId: v,
                                branchStateId: null,
                                branchCityId: null,
                            });

                            // this.loadStates(v);
                        },
                    },
                    {
                        label: "Select State",
                        key: "branchStateId",
                        required: true,
                        type: "select",
                        showSearch: true,
                        options: states,
                        onChange: (v) => {

                            this.props.form.setFieldsValue({
                                branchStateId: v,
                                branchCityId: null,
                            });

                            // this.loadBranches(v);
                            this.loadCities(v);
                        },
                    },
                    {
                        label: "Select City",
                        key: "branchCityId",
                        required: true,
                        showSearch: true,
                        type: "select",
                        options: cities,
                        onChange: (v) => {

                            this.props.form.setFieldsValue({
                                branchCityId: v,
                            });

                        },
                    },
                    {
                        label: "Branch Landline Phone One",
                        key: "branchPhone1"
                    },

                    {
                        label: "Branch Landline Phone Two",
                        key: "branchPhone2"
                    },
                    {
                        label: "Plan",
                        key: "plan",
                        type: "select",
                        showSearch: true,
                        allowClear: true,
                        options: plans,
                        // required: true,
                        disabled: true,
                        onChange: (v) => {

                            this.props.form.setFieldsValue({
                                plan: v,
                            });

                        },
                    },
                    {
                        label: "Name",
                        key: "branchHeadName",
                        prefixComp: <h3>Branch Head</h3>,
                    },
                    {
                        label: "Country Code",
                        key: "countryCode",
                        type: "select",
                        showSearch: true,
                        options: countryCodes,
                        onChange: v => {

                            this.props.form.setFieldsValue({
                                countryCode: v,
                            });

                        }
                    },

                    {
                        label: "Phone",
                        key: "branchHeadPhone"
                    },

                    {
                        label: "Email",
                        key: "branchHeadEmail"
                    },
                    {
                        label: "Name",
                        key: "branchManagerName",
                        prefixComp: <h3>Branch Manager</h3>,
                    },

                    {
                        label: "Country Code",
                        key: "branchManagerPhoneCode",
                        type: "select",
                        options: countryCodes,
                        showSearch: true,
                        onChange: v =>
                            this.props.form.setFieldsValue({
                                branchManagerPhoneCode: v
                            })
                    },

                    {
                        label: "Phone",
                        key: "branchManagerPhone"
                    },

                    {
                        label: "Email",
                        key: "branchManagerEmail"
                    },

                    // COUNSELLOR
                    {
                        label: "Name",
                        key: "branchHeadCounslerName",
                        prefixComp: <h3>Branch Counsellor</h3>,
                    },

                    {
                        label: "Country Code",
                        key: "branchHeadCounslerPhoneCode",
                        type: "select",
                        options: countryCodes,
                        showSearch: true,
                        onChange: v =>
                            this.props.form.setFieldsValue({
                                branchHeadCounslerPhoneCode: v
                            })
                    },

                    {
                        label: "Phone",
                        key: "branchHeadCounslerPhone"
                    },

                    {
                        label: "Email",
                        key: "branchHeadCounslerEmail"
                    },
                ]
            },
            {
                tabTitle: "Payment Terms",
                fields: [
                    {
                        label: "Commission",
                        type: "number",
                        key: "commission",
                        disabled: true,
                        rightComp: (
                            <span style={{ paddingLeft: "5px" }}>
                                %
                            </span>
                        ),
                    },
                    {
                        label: "PAYMENT Terms",
                        key: "paymentTerms",
                        type: "textArea",
                        disabled: true,
                        rows: 5,
                    },
                    // {
                    //     label: "PAYMENT Guidelines Document",
                    //     key: "paymentUpload",
                    //     type: "file",
                    // },
                    // {
                    //     label: "Bank Details 1",
                    //     key: "bankDetails1",
                    //     type: "textArea",
                    //     rows: 5,
                    // },

                    // {
                    //     label: "Bank Details 2",
                    //     key: "bankDetails2",
                    //     type: "textArea",
                    //     rows: 5,
                    // },

                    {
                        label: "Bank Name",
                        key: "bankName",
                        required: true
                    },

                    {
                        label: "Branch Name & Address",
                        key: "branchNameAddress",
                        required: true
                    },

                    {
                        label: "Account No",
                        key: "accountNumber",
                        required: true
                    },

                    {
                        label: "Account Name",
                        key: "accountName",
                        required: true
                    },

                    {
                        label: "IFSC Code / Swift Code",
                        key: "ifsc",
                        required: true
                    },
                ]
            }
        ];
        let paymentUpload = data && data.paymentUpload;
        return (
            <PageHeaderWrapper title={"Update Branch"}>
                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                    <Card>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ marginBottom: 10 }}
                            loading={this.props.loading}
                        >
                            SAVE
                        </Button>

                        <Tabs onChange={this.callback} type="card">
                            {inputTypes.map((itype, key) => (
                                <TabPane tab={itype.tabTitle} key={key + 1}>
                                    <GetAllFormFields
                                        apiurl={LAPI_URL}
                                        inputSchema={inputTypes[key]}
                                        // refresh={this.refreshFxn}
                                        getFieldDecorator={getFieldDecorator}
                                    />
                                    {
                                        key == 1 && (
                                            paymentUpload &&
                                                paymentUpload.length > 0 &&
                                                paymentUpload[0] &&
                                                paymentUpload[0].url ? (

                                                <Button
                                                    onClick={() => {
                                                        window.open(
                                                            paymentUpload[0].url,
                                                            "_blank",
                                                            "noopener,noreferrer"
                                                        );
                                                    }}
                                                >
                                                    Download Agreement
                                                </Button>

                                            ) : (

                                                <p style={{ color: 'red' }}>Agreement not uploaded</p>

                                            )
                                        )
                                    }
                                </TabPane>
                            ))}
                        </Tabs>
                    </Card>
                </Form>

            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateBranch);